module.exports = __webpack_public_path__ + "3307248cda293422fd0cc12bfbdcd14b.jpg";